__webpack_require__.p = "/VUE_iqTest/";